import styled from "styled-components";
import { ReactComponent as HamburgerIcon } from "assets/icons/menu.svg";
import { Flex } from "Element/Flex";
import { SecondaryButton } from "Element/Button";

export const StyledHeaderWrapper = styled.div<{ isOpen?: boolean }>`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: 20px 72px;
  position: fixed;
  background-color: ${({ theme }) => theme.colors.neutral00};
  transition: all 0.15s ease-in-out;
  z-index: 10;
  ${({ theme, isOpen }) => theme.mediaWidth.upToMedium`
    height: ${isOpen ? "100%" : "146px"};
    padding: 20px 24px;
    gap: 12px;
    align-items: flex-start;
  `}
`;

export const StyledHeaderBrand = styled.div`
  display: flex;
  align-items: center;
  ${({ theme }) => theme.mediaWidth.upToMedium`
      justify-content: space-between;
      width: 100%;
  `}
`;

export const StyledNav = styled.nav`
  display: flex;
  flex-wrap: wrap;
  gap: 48px;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    display: none;
  `}
`;

export const MenuWrapper = styled.nav<{ isOpen: boolean }>`
  display: flex;
  flex-direction: column;
  padding: 24px;
  overflow: hidden;
  background-color: ${({ theme }) => theme.colors.neutral00};
  z-index: 5;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    width: 100%;
  `}
`;

export const MenuIcon = styled(HamburgerIcon)`
  cursor: pointer;
  display: none;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    display: block;
  `}
`;
export const StyledNavItem = styled.a`
  ${({ theme }) => theme.mediaWidth.upToMedium`
      font-size: 46px;
      font-weight: 700;
      text-align: center;
      :not(:last-child) {
        margin-bottom: 30px;
      }
  `}
`;

export const ConnectedStatus = styled(Flex)`
  background-color: ${({ theme }) => theme.colors.secondary00};
  color: ${({ theme }) => theme.colors.neutral00};
  padding: 4px 6px;
  border-radius: 2px;
  font-weight: 700;
  font-size: 14px !important;
  ${({ theme }) => theme.fontStyle.button}

  svg {
    width: 16px;
    height: 16px;
    path {
      fill: ${({ theme }) => theme.colors.neutral00};
    }
  }
`;

export const MenuItemWrapper = styled(Flex)`
  flex-direction: column;
  align-items: center;
`;

export const StyledConnectButton = styled(SecondaryButton)`
  ${({ theme }) => theme.mediaWidth.upToMedium`
    margin-top: auto;
    width: 100%;
  `}
`;

export const ConnectedWrapper = styled(Flex)`
  ${({ theme }) => theme.mediaWidth.upToMedium`
    margin-top: auto;
  `}
`;
